export const CONFIGURATION_SET = 'CONFIGURATION_SET';
export const configurationSet = (configuration) => ({ type: CONFIGURATION_SET, payload: configuration });
